<template>
  <svg
    style="width: 1em; height: 1em"
    viewBox="0 0 1024 1024"
    fill="currentColor"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M896 544H128c-19.2 0-32-12.8-32-32V256c0-6.4 6.4-19.2 6.4-25.6l192-192c6.4 0 19.2-6.4 25.6-6.4h512c51.2 0 96 44.8 96 96v384c0 19.2-12.8 32-32 32z m-736-64h704V128c0-19.2-12.8-32-32-32H332.8L160 268.8v211.2z"
    />
    <path
      d="M320 288H128c-12.8 0-25.6-6.4-32-19.2 0-12.8 0-25.6 6.4-38.4l192-192c12.8-6.4 25.6-6.4 38.4-6.4 12.8 6.4 19.2 19.2 19.2 32v192c0 19.2-12.8 32-32 32z m-115.2-64h83.2V140.8L204.8 224zM896 992H128c-51.2 0-96-44.8-96-96V512c0-19.2 12.8-32 32-32h896c19.2 0 32 12.8 32 32v384c0 51.2-44.8 96-96 96z m-800-448V896c0 19.2 12.8 32 32 32h768c19.2 0 32-12.8 32-32V544h-832z"
    />
    <path
      d="M768 768H256c-19.2 0-32-12.8-32-32s12.8-32 32-32h512c19.2 0 32 12.8 32 32s-12.8 32-32 32z"
    />
    <path
      d="M768 768H256c-19.2 0-32-12.8-32-32s12.8-32 32-32h512c19.2 0 32 12.8 32 32s-12.8 32-32 32zM736 384H704c-19.2 0-32-12.8-32-32s12.8-32 32-32h32c19.2 0 32 12.8 32 32s-12.8 32-32 32zM576 384H512c-19.2 0-32-12.8-32-32S492.8 320 512 320h64c19.2 0 32 12.8 32 32S595.2 384 576 384zM384 384H320c-19.2 0-32-12.8-32-32S300.8 320 320 320h64c19.2 0 32 12.8 32 32S403.2 384 384 384z"
    />
  </svg>
</template>
